import {PatternInterface} from './pattern.interface';

export interface PatternBatchInterface extends PatternInterface {
    readonly disposition: 'column' | 'row';
    elements: PatternInterface[];
}